import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Button, Spinner } from "react-bootstrap";
import { getAdminHeaders, getAdminUrl, getBuyerHeaders, getBuyerUrl } from 'shared/http';
import { adminContentUpdate, contentList, shopWithPurposeBgImageAdd } from 'shared/settings/apiconfig';
import './MysteryRewards.scss';

export const PrivacyPolicy = (props) => {
    const [pdfUrl, setPdfUrl] = useState(null);
    const [pdfName, setPdfName] = useState(null);
    const [pageLoading, setPageLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [uploadLoading, setUploadLoading] = useState(false);
    const [privacyPolicyMsg, setPrivacyPolicy] = useState({ show: false, type: "", msg: "" });
    const [premierData, setPremierData] = useState(null);
    const [base64, setBase64] = useState(null);
    const [fileData, setFileData] = useState(null);
    const [noDataMsg, setNoDataMsg] = useState(false);
    const [uploadError, setUploadError] = useState({ show: false, type: "", msg: "" });
    const [dragActive, setDragActive] = useState(false);
    const [orignalFile, setOriginalFile] = useState('');
    const [cancelPdfMsg, setCancelMessage] = useState('')

    useEffect(() => {
        setPageLoading(true);
        getContentList();
    }, []);

    const getContentList = () => {
        setNoDataMsg(false);
        let data = {
            filter: [
                { field: "status", value: "Active", op: "=", join: "AND" },
                { field: "screenname", value: "privacy-policy", op: "=", join: "AND" },
                { field: "contenttype", value: "JSON", op: "=", join: "AND" }
            ]
        };

        axios.post(getBuyerUrl(contentList), data, getBuyerHeaders()).then(response => {
            if (response.data.status.toLowerCase() === 'success') {
                const responseData = response.data.data[0];
                setPremierData(responseData);
                const jsonData = JSON.parse(responseData.jsoncontent);

                setPdfUrl(jsonData.pdfUrl);
                setOriginalFile(jsonData.pdfUrl)

            } else {
                setNoDataMsg(true);
            }
            setPageLoading(false);
        }).catch(() => {
            setNoDataMsg(true);
            setPageLoading(false);
        });
    };

    const handleFile = (file) => {
        if (file && file.type === 'application/pdf') {
            setPdfName(file.name);
            setPdfUrl('');
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                const base64String = reader.result.split(',')[1];
                setBase64(base64String);
                setFileData(file);
                setUploadLoading(false);
            };
        } else {
            setUploadLoading(false);
            setPrivacyPolicy({ show: true, type: "error", msg: "Please upload a valid PDF file." });
        }
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
    
        // Strict check: must be PDF extension and correct MIME type
        const isPdf = file && file.name.toLowerCase().endsWith(".pdf") && file.type === "application/pdf";
    
        if (isPdf) {
            setUploadLoading(true);
            setPdfName(file.name);
            setPrivacyPolicy({ show: false, type: "", msg: "" });
            handleFile(file);
        } else {
            setPdfName("");
            setUploadLoading(false);
            setPrivacyPolicy({
                show: true,
                type: "error",
                msg: "Only PDF files are allowed.",
            });
        }
    
        // Allow selecting the same file again later
        event.target.value = null;
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            handleFile(e.dataTransfer.files[0]);
            e.dataTransfer.clearData();
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setDragActive(true);
    };

    const handleDragLeave = () => {
        setDragActive(false);
    };

    const cancelUpload = () => {
        setUploadLoading(false);
        setPrivacyPolicy({ show: false, type: "", msg: "" });
        setLoading(false);
        setPdfUrl(null);
        setPdfName(null);
        setBase64(null);
        setFileData(null);
        setCancelMessage('')
    };

    const uploadFile = () => {
        setCancelMessage('')
        setUploadLoading(true);
        const payload = {
            url: base64,
            type: 'pdf'
        };


        axios.post(getAdminUrl(shopWithPurposeBgImageAdd), JSON.stringify({ data: payload }), getAdminHeaders()).then(response => {
            if (response.data.status === "success") {
                setPdfUrl(response.data.data);
                setUploadLoading(false);
            }
        }).catch(error => {
            setUploadLoading(false);
            setUploadError({ show: true, type: "error", msg: error.response?.data?.message || "Upload failed." });
        });
    };

    const savePrivacyPolicy = () => {
        setLoading(true);
        const PrivacyData = {
            id: premierData.id,
            jsoncontent: {
                pdfUrl: pdfUrl
            }
        };

        axios.put(getAdminUrl(adminContentUpdate), { data: PrivacyData }, getAdminHeaders()).then(response => {
            if (response.data.status.toLowerCase() === 'success') {
                setLoading(false);
                setPrivacyPolicy({ show: true, type: "success", msg: 'Privacy Policy document is uploaded successfully' });
                setCancelMessage('')
                setTimeout(() => setPrivacyPolicy({ show: false, type: "", msg: "" }), 5000);
            }
        }).catch(error => {
            setLoading(false);
            setPrivacyPolicy({ show: true, type: "error", msg: error.response?.data?.message || "Save failed." });
            setTimeout(() => setPrivacyPolicy({ show: false, type: "", msg: "" }), 5000);
        });
    };

    const cancelPdf = () => {
        setCancelMessage("Previous file restored.")
        setPdfUrl(orignalFile)
    };

    return (
        <div className="mystery-reward h-100 p-5 pd-resp" style={{ overflowY: "scroll" }}>
            {pageLoading ? (
                <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100">
                    <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                </div>
            ) : noDataMsg ? (
                <div className='d-flex h-100 align-items-center justify-content-center'>
                    No Data Found
                </div>
            ) : (
                <>
                    <h3 className='font-weight-bold'>Privacy Policy</h3>
                    <h5 className='mt-5 font-weight-bold'>Upload Document</h5>

                    {<div
                        className='mt-5 d-flex justify-content-center'
                        onDrop={handleDrop}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                    >
                        <div style={{
                            width: '700px',
                            padding: '30px',
                            borderRadius: '10px',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                            backgroundColor: '#fff',
                            position: 'relative',
                            transition: '0.3s',
                            border: dragActive ? '2px dashed #6366f1' : 'none'
                        }}>
                            <div className='d-flex justify-content-between align-items-center text-center w-100 mb-3'>
                                <h5 className='font-weight-bold m-0 text-center w-100'>Upload files</h5>
                            </div>


                            {
                                pdfUrl ?
                                    <div className='mt-3 w-100 text-center'>
                                        {cancelPdfMsg ? <span className='text-success'>
                                            {cancelPdfMsg}
                                        </span> :
                                            <>
                                                {pdfUrl}
                                            </>}



                                    </div> :
                                    pdfName ?
                                        <div className='mt-3 text-center w-100' style={{ wordBreak: "break-word" }}>{pdfName}</div> :
                                        <>
                                            <label htmlFor="pdf-upload" className="d-flex flex-column align-items-center justify-content-center p-4 mb-3"
                                                style={{
                                                    border: "2px dashed #d3d3d3",
                                                    borderRadius: "10px",
                                                    cursor: "pointer",
                                                    textAlign: "center",
                                                    backgroundColor: dragActive ? '#f9f9ff' : 'transparent'
                                                }}>
                                                <img src={`${process.env.PUBLIC_URL}/static/images/upload.png`} alt="Upload" height="40" />
                                                <p className='mt-3 mb-1' style={{ fontWeight: 500 }}>Drop files here</p>
                                                <p className='mb-1' style={{ fontSize: "0.85rem", color: "#666" }}>Supported format: PDF</p>
                                                <strong className='my-1'>OR</strong>
                                                <div style={{ color: "#6366f1", textDecoration: "underline" }}>Browse files</div>
                                            </label>
                                            <input type="file"  accept=".pdf"  id="pdf-upload" style={{ display: "none" }} onChange={handleFileChange} />
                                        </>}



                            <div className="d-flex justify-content-center mt-3">

                                {pdfUrl && <Button clas onClick={cancelUpload}  >
                                    Replace
                                </Button>}
                                {(pdfName && !pdfUrl) && <Button onClick={uploadFile} className='ml-2' >
                                    Upload {loading || uploadLoading ? <Spinner as="span" animation="border" size="sm" /> : ''}
                                </Button>}
                                {/* )} */}
                            </div>
                        </div>
                    </div>}

                    {uploadError.show && (
                        <div className='d-flex align-items-center justify-content-center font-weight-bold mt-3' style={{ color: "red" }}>
                            {uploadError.msg}
                        </div>
                    )}

                    {privacyPolicyMsg.show && (
                        <div className='d-flex align-items-center justify-content-center mt-5 font-weight-bold'
                            style={{ color: privacyPolicyMsg.type === "success" ? "green" : "red" }}>
                            {privacyPolicyMsg.msg}
                        </div>
                    )}

                    <div className="d-flex align-items-center justify-content-center mt-5">
                        <Button onClick={() => cancelPdf()} style={{ marginLeft: "10px" }} disabled={privacyPolicyMsg.type === "error" || loading}>Cancel</Button>
                        <Button className='btn-secondary' onClick={savePrivacyPolicy} style={{ marginLeft: "10px" }} disabled={!pdfName || !pdfUrl || loading}>
                            Save {loading ? <Spinner as="span" animation="border" size="sm" /> : ''}
                        </Button>
                    </div>
                </>
            )}
        </div>
    );
};

export default PrivacyPolicy;
